export const size = {
  0: '0rem',        // 0px
  25: '0.0625rem',  // 1px
  50: '0.125rem',   // 2px
  100: '0.25rem',   // 4px
  150: '0.375rem',  // 6px
  200: '0.5rem',    // 8px
  300: '0.75rem',   // 12px
  350: '0.875rem',  // 14px
  400: '1rem',      // 16px
  450: '1.125rem',  // 18px
  500: '1.25rem',   // 20px
  600: '1.5rem',    // 24px
  700: '1.75rem',   // 28px
  800: '2rem',      // 32px
  900: '2.25rem',   // 36px
  1000: '2.5rem',   // 40px
  1200: '3rem',     // 48px
  1350: '3.5rem',   // 56px
  1500: '3.75rem',  // 60px
  2000: '5rem',     // 80px
  3000: '7.5rem',   // 120px
  3500: '8.75rem',  // 140px
  4000: '10rem',    // 160px
};

export default size;